exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".office_index[data-v-15267c4f]{padding:0}.office_index .main[data-v-15267c4f]{height:73vh}.office_index .left[data-v-15267c4f]{padding:30px;background-color:#f5f5f5;overflow:auto}.office_index .model_wrap[data-v-15267c4f]{width:375px}.office_index .model_wrap>div.active[data-v-15267c4f]{border:1px solid #2993ff}.office_index .right[data-v-15267c4f]{width:420px;overflow-y:auto}.office_index .right .header[data-v-15267c4f]{padding:15px;border-bottom:1px solid #eeeeee}.office_index .right .footer[data-v-15267c4f]{padding:15px 0;border-top:1px solid #eeeeee}.office_index .main_form[data-v-15267c4f]{padding:15px 20px}\n", ""]);

// exports
